import { Component, Input, OnInit } from "@angular/core";
import { DashboardVisitorService } from "../dashboard-visitor.service";

@Component({
	selector: "caass-facility-stats-ytd",
	templateUrl: "./facility-stats-ytd.component.html",
	styleUrls: ["./facility-stats-ytd.component.css"],
})
export class FacilityStatsYTDComponent implements OnInit {
	constructor(private dashboardService: DashboardVisitorService) {}

	ngOnInit(): void {
		this.UpdateOption();
	}

	ngOnChanges() {
		this.UpdateOption();
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	@Input() FacilityID: any;
	@Input() FacilityStatPanel: string;

	Title: string = "Facility Week to Date";
	OptionID: number = 0; //0 Week, 1 Month, 2 Year

	VisitorCount: string = "N/A";
	CheckPointCount: string = "N/A";
	DeniedEntryCount: string = "N/A";

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////

	loadData() {
		this.ResetData();

		if (this.FacilityID == undefined || this.FacilityID <= 0) {
			return;
		}

		var result = this.dashboardService.FacilityVisitorStatsSelect(this.FacilityID, this.OptionID);
		result.subscribe(
			(response) => {
				var data: any = response;

				try {
					this.VisitorCount = String(data.VisitorCount);
					this.CheckPointCount = String(data.CheckPointCount);
					this.DeniedEntryCount = String(data.DeniedEntryCount);
				} catch (e) {
					e.toString();
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility Week to Date";
		} else if (this.OptionID == 1) {
			this.Title = "Facility Month to Date";
		} else if (this.OptionID == 2) {
			this.Title = "Facility Year to Date";
		}

		this.loadData();
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	ResetData() {
		this.VisitorCount = "N/A";
		this.CheckPointCount = "N/A";
		this.DeniedEntryCount = "N/A";
	}

	UpdateOption() {
		if (this.FacilityStatPanel != undefined) {
			if (this.FacilityStatPanel == "WTD") {
				this.OptionID = 0;
			} else if (this.FacilityStatPanel == "MTD") {
				this.OptionID = 1;
			} else if (this.FacilityStatPanel == "YTD") {
				this.OptionID = 2;
			}

			this.loadData();
		}
	}

	////////////////////////////////////////////////////////////////////////
}
